export const initialState = {
  name: 'admin',
  version: '1.0',
  platform: 'web',
};

const ACTION_HANDLERS = {};

export default function appReducer(state = initialState, action = {}) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
